import React, { useEffect } from 'react';
import styles from './dimijs/src/lib/theme/base.module.scss';
import cn from 'classnames';

import {Routes, Route, useLocation} from 'react-router-dom';
import {FormRegister} from './pages/FormRegister';
import {FormLogin} from './pages/FormLogin';
import {Panel} from './pages/Panel';
import {Page} from './pages/Page';
import modalStyles from './dimijs/src/lib/components/Modal.module.scss';
import {Collections} from './pages/panel/Collections';
import {DataContext} from './dimijs/src/lib/utils/dataContext';
import {Users} from './pages/panel/Users';
import {useAnalytics} from './hooks/useAnalytics';

// Analytics wrapper component
function AnalyticsWrapper({ children }) {
  const location = useLocation();
  const { trackPageView, trackNavigation } = useAnalytics();
  const prevLocation = React.useRef(location.pathname);

  useEffect(() => {
    // Track page views
    trackPageView(location.pathname);
    
    // Track navigation
    if (prevLocation.current !== location.pathname) {
      trackNavigation(prevLocation.current, location.pathname, 'programmatic');
      prevLocation.current = location.pathname;
    }
  }, [location.pathname, trackPageView, trackNavigation]);

  return <>{children}</>;
}

function App(props) {
  const MainRouter = props.MainRouter;
  return (
    <DataContext initProps={props.initProps} store={props.store}
      ssrDataCollector={props.ssrDataCollector}>
      <MainRouter {...props.routerProps}>
        <AnalyticsWrapper>
          <div className={cn(styles.root)}>
            <Routes>
              <Route path="/form" element={<FormRegister />} />
              <Route path="/login" element={<FormLogin />} />
              <Route path="/panel" element={<Panel />} />
              <Route path="/panel/collections" element={<Collections />} />
              <Route path="/panel/users" element={<Users />} />
              <Route path="/p/*" element={<Page />} />
              <Route path="/" element={<Page />} />
            </Routes>
            <div className={modalStyles.modalRoot} id={'modalRoot'}></div>
          </div>
        </AnalyticsWrapper>
      </MainRouter>
    </DataContext>
  );
}

export default App;
